import { objectUtil } from "../../../utils";
import logLevels from "../logLevels";

const minLogLevel = process.env.REACT_APP_CONSOLE_MIN_LOG_LEVEL ?? logLevels.ERROR.name;
const consoleLogEnabled = process.env.REACT_APP_CONSOLE_LOG_SERVICE_ENABLED;

const getMinLogLevel = () => {
  const level = logLevels[minLogLevel] ?? logLevels.ERROR;
  return level;
};

const formatLogMessage = (logLevel, msg, error) => {
  const date = new Date().toISOString();
  const dateFormatted = date.substr(11, 12);
  const errorMsg = prepareErrorMessage(error);
  return `${dateFormatted} | ${logLevel.name} | ${msg}${errorMsg}`;
};

const prepareErrorMessage = (error) => {
  let errorMessage = "";
  if (!error || error === "undefined") return errorMessage;

  if (objectUtil.isObject(error)) {
    if (error?.config?.headers && objectUtil.isObject(error.config.headers)) {
      for (const key of Object.keys(error.config.headers)) {
        error.config.headers[key] = "n/a";
      }
    }

    errorMessage = JSON.stringify(error, Object.getOwnPropertyNames(error));
  } else {
    errorMessage = error;
  }

  return ` | Error: ${errorMessage}`;
};

const log = (logLevel, msg, data) => {
  if (!consoleLogEnabled) {
    return;
  }
  const minLevel = getMinLogLevel();
  if (logLevel.id < minLevel.id) return;

  if (logLevel.id < logLevels.WARN.id) {
    console.log(formatLogMessage(logLevel, msg, data));
  } else if (logLevel.id === logLevels.WARN.id) {
    console.warn(formatLogMessage(logLevel, msg, data));
  } else {
    console.error(formatLogMessage(logLevel, msg, data));
  }
};

const consoleLogger = {
  trace: (msg) => {
    log(logLevels.TRACE, msg);
  },
  debug: (msg) => {
    log(logLevels.DEBUG, msg);
  },
  info: (msg) => {
    log(logLevels.INFO, msg);
  },
  warn: (msg, error) => {
    log(logLevels.WARN, msg, error);
  },
  error: (msg, error) => {
    log(logLevels.ERROR, msg, error);
  },
  fatal: (msg, error) => {
    log(logLevels.FATAL, msg, error);
  }
};

export default consoleLogger;
